import React from 'react'
import styled from 'styled-components'

// Icons
import { ReactComponent as CrossIcon } from '@sketch/icons/cross-16-svg'

// Constants
import { SKETCH_WEBSITE } from '@sketch/constants'

// Hooks
import { getIsForInAppPresentation } from 'modules/user/hooks'

// Components
import { IconButton, Flex, Caption } from '@sketch/components'

const Container = styled(Flex)`
  border-radius: 2rem; /* stylelint-disable-line scales/radii */
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  background-clip: padding-box;
  padding: 8px 16px 8px 1.4rem; /* stylelint-disable-line scales/space */
  justify-content: center;
`

const CookieCaption = styled(Caption)`
  margin: 0;
`

const CookieLink = styled.a`
  font-weight: 400;
`

interface Props {
  onClickClose: () => void
}

const CookieBanner = ({ onClickClose }: Props) => {
  const isForInAppPresentation = getIsForInAppPresentation()
  const target = isForInAppPresentation ? '_self' : '_blank'

  return (
    <Container>
      <Flex justifyContent="center">
        <CookieCaption color="#000">
          By using Sketch, you agree to our{' '}
          <CookieLink
            href={`${SKETCH_WEBSITE}/tos`}
            target={target}
            rel="noopener noreferrer"
          >
            Terms of Service
          </CookieLink>
          .
        </CookieCaption>
        <IconButton
          icon={CrossIcon}
          onClick={onClickClose}
          style={{ marginLeft: '1rem' }}
        />
      </Flex>
    </Container>
  )
}

export default CookieBanner
